import {combineEpics, Epic} from 'redux-observable';
import {from, of} from 'rxjs';
import {
  switchMap,
  map,
  startWith,
  catchError,
  filter
} from 'rxjs/operators';
import {isOfType} from 'typesafe-actions';

import {
  SubscriptionActions,
  SubscriptionActionTypes,
  loadedProducts,
  loadingProducts,
  loadingProductsFailed,
  startingTrial,
  startedTrial,
  startingTrialFailed,
} from '../actions/subscriptionActions';
import {IState} from '../reducers';
import {
  subscriptionLoadProducts,
  subscriptionStartTrial
} from '../../services/subscriptionApi';

const loadProductsEpic: Epic<SubscriptionActions, SubscriptionActions, IState> = (
  action$: any,
  state$: any,
  {dispatch}: any
) =>
  action$.pipe(
    filter(isOfType(SubscriptionActionTypes.LOAD_PRODUCTS)),
    switchMap((action: any) =>
      from(subscriptionLoadProducts()).pipe(
        map((response: any) => {
          return loadedProducts(response);
        }),
        startWith(loadingProducts()),
        catchError(() => of(loadingProductsFailed()))
      )
    )
  );

const startTrialEpic: Epic<SubscriptionActions, SubscriptionActions, IState> = (
  action$: any,
  state$: any,
  {dispatch}: any
) =>
  action$.pipe(
    filter(isOfType(SubscriptionActionTypes.START_TRIAL)),
    switchMap((action: any) =>
      from(subscriptionStartTrial()).pipe(
        map((response: any) => {
          return startedTrial();
        }),
        startWith(startingTrial()),
        catchError(() => of(startingTrialFailed()))
      )
    )
  );

export default combineEpics(
  loadProductsEpic,
  startTrialEpic,
);
